import { format } from 'date-fns/format';
import { addMonths } from 'date-fns/addMonths';
import { momentToDateFns } from '../momentToDateFns';
// If scrolling references, say for Example:- first 5 months are 300, 600, 900, 1200, 1500
// These numbers are pixels representing the horizonatl or vertical scroll reference.
// And the container(with 2 months to show) is scrolled to 350, then everything from 350 to 950(2 months to show)
// would be visible on the screen.
// 350 would mean that first month is partially displayed,so we take the lower limit as 300.
// Similarly we take upper limit as 900. We then use the indexes of these limits to get apprpriate months.
export const getLowerLimitIndex = (value, offsetArray) => {
  if (value > offsetArray[offsetArray.length - 1]) {
    offsetArray.push(value);
  }
  let limit = 0;
  for (let index = 0; index < offsetArray.length && offsetArray[index] <= value; index++) {
    limit = index;
  }
  return limit;
};
export const getUpperLimitIndex = (value, offsetArray) => {
  if (value > offsetArray[offsetArray.length - 1]) {
    offsetArray.push(value);
  }
  let limit = 0;
  for (let index = 0; index < offsetArray.length && offsetArray[index] < value; index++) {
    limit = index;
  }
  return limit;
};
// This method returns the months that are displayed on the screen, considering both
// horizontal scroll for desktop and vertical scroll for mobile. The logic does not add constraints
// to all months to have a fixed height or width, therefore the following function will work
// even when widths and heights of different month cards are not same.
const getMonthsInView = (startMonth, scrollBoxNode, scrollBoxContainerNode) => {
  // validation for arguments passed to this function
  if (!startMonth || !scrollBoxNode || !scrollBoxNode.children || scrollBoxNode.children.length < 2 || !scrollBoxContainerNode) {
    return null;
  }
  const displayedFromMonth = momentToDateFns(startMonth);
  const displayedToMonth = momentToDateFns(startMonth);
  if (!displayedFromMonth || !displayedToMonth) return null;
  const containerHeight = scrollBoxContainerNode.clientHeight;
  const containerWidth = scrollBoxContainerNode.clientWidth;
  const monthChildOffsets = [];
  let scrollingLength = 0;
  let scrollReference = 0;
  if (scrollBoxNode.children[0].offsetTop === scrollBoxNode.children[1].offsetTop) {
    // Desktop with horizontal scroll
    scrollingLength = containerWidth;
    scrollReference = Math.round(scrollBoxContainerNode.scrollLeft);
    for (let index = 0; index < scrollBoxNode.children.length; index++) {
      monthChildOffsets.push(scrollBoxNode.children[index].offsetLeft);
    }
  } else {
    // mobile with vertical scroll
    scrollingLength = containerHeight;
    scrollReference = Math.round(scrollBoxContainerNode.scrollTop);
    for (let index = 0; index < scrollBoxNode.children.length; index++) {
      monthChildOffsets.push(scrollBoxNode.children[index].offsetTop);
    }
  }
  const lowerLimit = getLowerLimitIndex(scrollReference, monthChildOffsets);
  const upperLimit = getUpperLimitIndex(scrollReference + scrollingLength, monthChildOffsets);
  const fromMonth = addMonths(displayedFromMonth, lowerLimit);
  const toMonth = addMonths(displayedToMonth, upperLimit);
  return {
    displayedFromMonth: format(fromMonth, 'yyyyMM'),
    displayedToMonth: format(toMonth, 'yyyyMM')
  };
};
export default getMonthsInView;